import React from 'react';
import { DataList } from 'commons-ui';
import { LIST_ENTITY_NAMES } from '../../../../../settingsV2Constant';
import { columnConfigs, IUserPermissionsDetails } from './listConfig';
import useService from './useService';

const UserPermissionsDetails: React.FC<any> = (props: IUserPermissionsDetails) => {
	const { userPermissionsData } = props;
	const { getUserPermissionsData } = useService(userPermissionsData);
	return (
		<DataList
			fetchData={getUserPermissionsData}
			columnConfigs={columnConfigs}
			hideActions
			entity={LIST_ENTITY_NAMES.USERS}
			rowHeight={60}
		/>
	);
};

export default UserPermissionsDetails;
